import { captureException, captureMessage } from "@/lib/sentry";

/**
 * Production-safe logging utility
 * In development: logs to console
 * In production: sends errors to Sentry
 */

export const logger = {
  error: (message: string, error?: Error | unknown, context?: Record<string, any>) => {
    if (import.meta.env.DEV) {
      console.error(message, error, context);
    }
    if (error instanceof Error) {
      captureException(error, context);
    } else {
      captureMessage(message, "error");
    }
  },

  warn: (message: string, context?: Record<string, any>) => {
    if (import.meta.env.DEV) {
      console.warn(message, context);
    }
    captureMessage(message, "warning");
  },

  info: (message: string, context?: Record<string, any>) => {
    if (import.meta.env.DEV) {
      console.log(message, context);
    }
  },

  debug: (message: string, data?: any) => {
    if (import.meta.env.DEV) {
      console.log(message, data);
    }
  }
};
